import axios from "axios";

function mapFieldErrors(errors) {
  if (!Array.isArray(errors)) {
    return {};
  }

  return errors.reduce((accumulator, error) => {
    if (error?.field && error?.message) {
      accumulator[error.field] = error.message;
    }

    return accumulator;
  }, {});
}

export function normalizeApiError(error) {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data;

    return {
      message: responseData?.message || error.message || "Request failed.",
      status: error.response?.status || 500,
      fieldErrors: mapFieldErrors(responseData?.errors),
      details: responseData?.errors || null,
      raw: error,
    };
  }

  return {
    message: error?.message || "Something went wrong.",
    status: 500,
    fieldErrors: {},
    details: null,
    raw: error,
  };
}
